import React from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';

interface PhoneInputProps {
  label: string;
  phoneRegister: ReturnType<UseFormRegister<any>>;
  countryCodeRegister: ReturnType<UseFormRegister<any>>;
  phoneError?: FieldError;
  countryCodeError?: FieldError;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  label,
  phoneRegister,
  countryCodeRegister,
  phoneError,
  countryCodeError,
  disabled = false,
  placeholder = "(85) 99999-9999",
  required = false
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="flex">
        <select
          {...countryCodeRegister}
          className="block w-24 px-3 py-2 border border-gray-300 rounded-l-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          disabled={disabled}
        >
          <option value="+55">🇧🇷 +55</option>
          <option value="+1">🇺🇸 +1</option>
          <option value="+44">🇬🇧 +44</option>
          <option value="+33">🇫🇷 +33</option>
          <option value="+49">🇩🇪 +49</option>
          <option value="+34">🇪🇸 +34</option>
          <option value="+39">🇮🇹 +39</option>
          <option value="+351">🇵🇹 +351</option>
        </select>
        <input
          {...phoneRegister}
          type="tel"
          placeholder={placeholder}
          className="flex-1 block px-3 py-2 border border-l-0 border-gray-300 rounded-r-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          disabled={disabled}
        />
      </div>
      {(phoneError || countryCodeError) && (
        <p className="mt-1 text-sm text-red-600">
          {phoneError?.message || countryCodeError?.message}
        </p>
      )}
    </div>
  );
};

export default PhoneInput;
